/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.to-string.js";
export default {
  // 品牌类型
  EnumBrandType: {
    Cachito: {
      Description: 'Cachito',
      Value: 1,
      Type: ''
    },
    iCHOKer: {
      Description: 'iCHOKer',
      Value: 2,
      Type: ''
    },
    JuYouJing: {
      Description: '橘右京',
      Value: 3,
      Type: ''
    }
  },
  // 订单状态
  OrderStatus: {
    Address: {
      Description: '待填址',
      Value: 1
    },
    WaitSending: {
      Description: '待发货',
      Value: 2
    },
    Shipped: {
      Description: '已发货',
      Value: 3
    },
    Backout: {
      Description: '已撤销',
      Value: 4
    },
    ErpSend: {
      Description: 'ERP已发货',
      Value: 5
    },
    ErpClose: {
      Description: 'ERP交易关闭',
      Value: 6
    }
  },
  // 订单状态
  OrderStatusList: {
    WaitPay: {
      Description: '待支付',
      Value: 0,
      Color: '#8F7918',
      BgColor: '#FFF2BA'
    },
    Paid: {
      Description: '已支付',
      Value: 1,
      Color: '#486B31',
      BgColor: '#E1F6D3'
    },
    WarehouseShipped: {
      Description: '仓库已发货',
      Value: 2,
      Color: '#3A4B80',
      BgColor: '#D3DEFF'
    },
    Paying: {
      Description: '支付中',
      Value: 3,
      Color: '#8F7918',
      BgColor: '#FFF2BA'
    },
    PayFailed: {
      Description: '支付失败',
      Value: 4,
      Color: '#BB0A0A',
      BgColor: '#FCDCDC'
    },
    PartialRefund: {
      Description: '部分退款',
      Value: 5,
      Color: '#BB0A0A',
      BgColor: '#FCDCDC'
    },
    Refunded: {
      Description: '已退款',
      Value: 6,
      Color: '#BB0A0A',
      BgColor: '#FCDCDC'
    },
    ERPShipped: {
      Description: 'ERP已发货',
      Value: 7,
      Color: '#3A4B80',
      BgColor: '#D3DEFF'
    },
    ERPCompleted: {
      Description: 'ERP交易完成',
      Value: 8,
      Color: '#486B31',
      BgColor: '#E1F6D3'
    },
    ERPClosed: {
      Description: 'ERP交易关闭',
      Value: 9,
      Color: '#BB0A0A',
      BgColor: '#FCDCDC'
    }
  },
  getDescription: function getDescription(obj, val) {
    var str = "";
    Object.keys(obj).find(function (key) {
      if (val == obj[key].Value) {
        str = obj[key].Description;
      }
    });
    return str;
  },

  /**
   * @describe 对象转数组
   * @param  {Object} obj 指定枚举
   * 示例：
   * let obj = { a: { Description: '选项一', Value: 1 }, b: { Description: '选项二', Value: 2 } }
   * Enums.getNameValueList(obj) = [{name: '选项一', value: 1},{name: '选项二', value: 2}]
   */
  getNameValueList: function getNameValueList(obj) {
    var arr = [];
    Object.keys(obj).forEach(function (key) {
      arr.push({
        name: obj[key].Description,
        value: obj[key].Value
      });
    });
    return arr;
  },

  /**
   * @describe 对象转数组
   * @param  {Object} obj 指定枚举
   * 示例：
   * let obj = { a: { Description: '选项一', Value: 1 }, b: { Description: '选项二', Value: 2 } }
   * Enums.getTextValueList(obj) = [{text: '选项一', value: 1},{text: '选项二', value: 2}]
   */
  getTextValueList: function getTextValueList(obj) {
    var arr = [];
    Object.keys(obj).forEach(function (key) {
      arr.push({
        text: obj[key].Description,
        value: obj[key].Value
      });
    });
    return arr;
  },

  /**
   * @describe 对象转数组
   * @param  {Object} obj 指定枚举
   * 示例：
   * let obj = { a: { Description: '选项一', Value: 1 }, b: { Description: '选项二', Value: 2 } }
   * Enums.getLabelValueList(obj) = [{label: '选项一', value: 1},{label: '选项二', value: 2}]
   */
  getLabelValueList: function getLabelValueList(obj) {
    var arr = [];
    Object.keys(obj).forEach(function (key) {
      arr.push({
        label: obj[key].Description,
        value: obj[key].Value.toString()
      });
    });
    return arr;
  },

  /**
   * @describe 获取枚举项对应的key
   * @param  {Object} obj 指定枚举
   * @param  {Number} val 枚举值Value
   * 示例：
   * let obj = { a: { Description: '选项一', Value: 1 }, b: { Description: '选项二', Value: 2 } }
   * Enums.getNameByValue(obj,1) = a;
   */
  getNameByValue: function getNameByValue(obj, val) {
    var name = "";
    Object.keys(obj).forEach(function (key) {
      if (val == obj[key].Value) {
        name = key;
      }
    });
    return name;
  },

  /**
   * @describe 根据Value遍历出指定枚举的某一项
   * @param {Object} obj 指定枚举
   * @param {Number} val 枚举值Value
   * 示例：
   * let obj = { a: { Description: '选项一', Value: 1 }, b: { Description: '选项二', Value: 2 } }
   * Enums.getItemByValue(obj,1) = { Description: '选项一', Value: 1 }
   */
  getItemByValue: function getItemByValue(obj, val) {
    var Item = Object.keys(obj).find(function (item) {
      return val == obj[item].Value;
    });
    return obj[Item];
  },
  getTipText: function getTipText(obj, val) {
    var str = '';
    Object.keys(obj).find(function (key) {
      if (val == obj[key].Value) {
        str = obj[key].TipText;
      }
    });
    return str;
  },
  getColor: function getColor(obj, val, name) {
    var str = '';
    Object.keys(obj).find(function (key) {
      if (val == obj[key].Value) {
        str = obj[key][name];
      }
    });
    return str;
  }
};